<template>
  <div id="eoi-form">
    <Form :questions="questions" @reset="reset" :min="min" :message="message" :error="error" />
  </div>
</template>

<script>
import Form from "./components/Form.vue";

export default {
  name: "app",
  components: {
    Form
  },
  data() {
    return {
      questions: [],
      min: 0,
      message: "",
      error: ""
    };
  },
  mounted() {
    this.defaultQuestions();
  },
  methods: {
    defaultQuestions() {
      let json_data = document.getElementById("eoi-data").innerHTML;
      json_data = JSON.parse(json_data);
      this.min = json_data.min;
      this.message = json_data.message;
      this.error = json_data.error;
      this.questions = json_data.questions.map(function(value) {
        value["select"] = "";
        return value;
      });
    },
    reset() {
      this.defaultQuestions();
    }
  }
};
</script>